package io.horion.cv.uiState

import io.horion.cv.api.datasource.common.PersonalInformation
import io.horion.cv.api.datasource.common.Type
import io.horion.cv.api.datasource.cv.Model
import io.horion.cv.api.datasource.cv.OrionCV

data class CvUiState(
    val loading: Boolean = false,
    val cvCreateSuccess: Boolean = false,
    val isConnected: Boolean = true,
    val data: OrionCV = OrionCV(
        personalInformation = PersonalInformation()
    ),
    val model : Model = Model.SIMPLE,
    val images : ByteArray? = null,
    val error: String? = null,
    val success: String? = null,
)
